import React from "react";
import { GradientDivider, WaveDivider } from "../components/UI";
import GradientSection from "../components/GradientSection";
import PageLayout from "../components/PageLayout";
import TeamMemberCard from "../components/TeamMemberCard";
import { getGradientClass } from "../constants/theme";
import { SITE_URL } from "../constants/site";
import { aboutMission, aboutStory, groupPhoto, racers } from "../data/team";

export default function About() {
    return (
        <PageLayout
            seo={{
                title: "About Osprey Racing Team - Meet Our Missoula Cyclists",
                description:
                    "Meet the Osprey Racing team  cyclists in Missoula, Montana. Learn about our riders, achievements, and cycling community.",
                url: `${SITE_URL}/about`,
                image: "/img/osprey-group.jpg",
                twitterDescription:
                    "Meet the Osprey Racing Team cyclists in Missoula, Montana.",
            }}
            title="About Osprey Racing"
        >
            <div className="relative mb-16 rounded-2xl overflow-hidden shadow-2xl">
                <img
                    src={groupPhoto}
                    alt="Osprey Racing Team"
                    className="w-full h-auto max-h-96 md:max-h-[500px] object-contain"
                />
            </div>

            <div className="grid md:grid-cols-2 gap-8 mb-16">
                <div className={`bg-gradient-to-br ${getGradientClass(0)} p-0.5 rounded-lg hover:scale-105 transition-transform duration-200`}>
                    <div className="bg-gray-800 p-6 rounded-lg h-full">
                        <h2 className="text-2xl font-bold mb-4 text-sky-400">Our Story</h2>
                        <p className="text-gray-300 mb-4">{aboutStory}</p>
                    </div>
                </div>
                <div className={`bg-gradient-to-br ${getGradientClass(1)} p-0.5 rounded-lg hover:scale-105 transition-transform duration-200`}>
                    <div className="bg-gray-800 p-6 rounded-lg h-full">
                        <h2 className="text-2xl font-bold mb-4 text-sky-400">Our Mission</h2>
                        <ul className="text-gray-300 list-disc list-inside">
                            {aboutMission.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            <GradientDivider />
            <WaveDivider />

            <GradientSection>
                <h2 className="text-2xl font-bold mb-8 text-sky-400 text-center">The Team</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {racers.map((racer, index) => (
                        <TeamMemberCard key={racer.id} racer={racer} index={index} />
                    ))}
                </div>
            </GradientSection>

            <GradientDivider />
        </PageLayout>
    );
}
